import { Button } from '@/components/common/Button';
import FadeInBox from '@/components/common/FadeInBox';
import { FlexCol, FlexRow } from '@/components/common/Flex';
import { Paragraph, Title } from '@/components/common/Typography';
import GoalIconCircle from '@/components/goals/GoalIconCircle';
import { showConfetti } from '@/util/confetti';
import { FlexProps } from '@chakra-ui/react';
import { Goal } from '@common/goals';
import { useEffect } from 'react';

export interface GoalOnboardingCelebrationProps extends FlexProps {
    goal: Goal;
    subtitle?: string;
    isLoading?: boolean;
    onComplete: () => void;
}

const GoalOnboardingCelebration = ({
    goal,
    subtitle,
    isLoading,
    onComplete,
    ...props
}: GoalOnboardingCelebrationProps) => {
    useEffect(() => {
        setTimeout(() => {
            showConfetti({ origin: { y: 0.6, x: 0.8 } });
        }, 500);
    }, []);

    return (
        <FlexRow
            pos="absolute"
            left={0}
            top={0}
            w="full"
            h="full"
            bg="white"
            alignItems="center"
            justifyContent="center"
            {...props}
        >
            <FlexCol alignItems="center" zIndex={0}>
                <FadeInBox>
                    <GoalIconCircle
                        size={20}
                        iconSize={10}
                        type={goal.type}
                        mb={10}
                    />
                </FadeInBox>
                <FadeInBox>
                    <Title fontWeight="600" mb={2}>
                        Here’s to the future!
                    </Title>
                </FadeInBox>
                <FadeInBox delay={3}>
                    <Paragraph mb={14}>
                        {subtitle
                            ? subtitle
                            : `Your ${goal.name} goal is all set up.`}
                    </Paragraph>
                </FadeInBox>
                <FadeInBox delay={4}>
                    <Button
                        pos="relative"
                        size="lg"
                        px={11}
                        onClick={onComplete}
                        onClickEvent="Goal Onboarding Continue Button Clicked"
                        onClickEventParams={{ step: 'CELEBRATION' }}
                        isLoading={isLoading}
                        isDisabled={isLoading}
                    >
                        Continue
                    </Button>
                </FadeInBox>
            </FlexCol>
        </FlexRow>
    );
};

export default GoalOnboardingCelebration;
